export interface DimensionRestraints {
  minWidth: number
  maxWidth: number
  minHeight: number
  maxHeight: number
}

export interface ImageDimensions {
  width: number
  height: number
}

export interface VideoRatio {
  width: number
  height: number
}

export interface RequiredImageDimensions
  extends Partial<DimensionRestraints>,
    Partial<ImageDimensions> {}

export interface RequiredVideoRatio extends Partial<DimensionRestraints>, Partial<VideoRatio> {}

export type RequiredImageDimensionsFn = (ImageDimensions) => boolean
export type RequiredVideoRatioFn = (VideoRatio) => boolean
export interface ImageUploaderProps {
  filestackApiKey: string
  value?: string
  onChange?: (uploadUrl: string, file: File, key: string) => void
  requiredDimensions?: RequiredImageDimensions | RequiredImageDimensionsFn
  requiredRatio?: RequiredVideoRatio | RequiredVideoRatioFn
  compact?: boolean
  path?: string
  requireEncodeFileName?: boolean
}

export enum FileError {
  InvalidDimensions = 'INVALID_DIMENSIONS',
  InvalidFile = 'INVALID_FILE',
}

export enum VideoOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Unknown = 'unknown',
}

export enum VideoFileRatio {
  LandscapeRatio = 16 / 9,
  PortraitRatio = 9 / 16,
}
